function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "22.08%",
  y1: "25.852%",
  x2: "84.568%",
  y2: "43.168%",
  id: "book-study_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D61772",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0398E",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50 48V0H6a6 6 0 00-6 6v48m50 6V48H6a6 6 0 00-6 6h0a6 6 0 006 6h44zM42 0v21l-8-5-8 5V0h16zm8 54H8",
  transform: "translate(1 1)",
  stroke: "url(#book-study_svg__a)",
  strokeWidth: 2,
  fill: "none",
  strokeLinecap: "square"
});

function SvgBookStudy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 62"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MiA2MiI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSIyMi4wOCUiIHkxPSIyNS44NTIlIiB4Mj0iODQuNTY4JSIgeTI9IjQzLjE2OCUiIGlkPSJhIj48c3RvcCBzdG9wLWNvbG9yPSIjRDYxNzcyIiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0EwMzk4RSIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZD0iTTUwIDQ4VjBINmE2IDYgMCAwMC02IDZ2NDhtNTAgNlY0OEg2YTYgNiAwIDAwLTYgNmgwYTYgNiAwIDAwNiA2aDQ0ek00MiAwdjIxbC04LTUtOCA1VjBoMTZ6bTggNTRIOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgc3Ryb2tlPSJ1cmwoI2EpIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjwvc3ZnPg==";
export { SvgBookStudy as ReactComponent };